// extracted by mini-css-extract-plugin
export default {"badgesContainer":"styles_badgesContainer__V2rKt","badges":"styles_badges__7KzaQ"};